<div class="clinical-main">
  Clinical Trials
</div>
<div *ngIf="noClinicalTrialsMessage" class="results-pane-value clinical-container">
  {{ noClinicalTrialsMessage}}
</div>
<section class="clinical" *ngIf="clinicalTrials && clinicalTrials.length">
  <div *ngFor="let clinicalTrial of clinicalTrials" class="Marginbox__t-small flexbox">
    <div class="Flexbox item fs6">
      <div class="left-content">
        <div class="clinicalName bold Marginbox__r-medium Marginbox__b-medium">
          {{clinicalTrial.name}}
        </div>
        <div class="Spacebox__t-small Flexbox">
          <div class="Spacebox__l-small text-gray Flexbox__flex-1">Target</div>
          <div class="bold Flexbox__flex-2">{{clinicalTrial.target}}</div>
          <div class="Flexbox Flexbox__flex-6">
            <div class="Spacebox__l-small text-gray Flexbox__flex-2">Nearest Recruiting Location</div>
            <div class="bold Flexbox__flex-7"> {{clinicalTrial.distance?.address}}
              <span
                *ngIf="clinicalTrial.distance && clinicalTrial.distance.absDistance">({{clinicalTrial.distance.absDistance
                | number : 2}}M) </span>
            </div>
          </div>
        </div>
        <div class="Spacebox__t-small Flexbox">
          <div class="Spacebox__l-small text-gray Flexbox__flex-1">Age Group</div>
          <div class="bold Flexbox__flex-2">{{clinicalTrial.ageGroup}}</div>
          <div class="Flexbox Flexbox__flex-6">
            <div class="Spacebox__l-small text-gray Flexbox__flex-2">Contact</div>
            <div class="bold Flexbox__flex-7"> {{clinicalTrial.contact || 'Not Available'}}</div>
          </div>
        </div>
      </div>
      <div class="content-delimiter"></div>
      <div class="right-content flexbox flexbox__direction-rows">
        <div class="Marginbox__b-small">
          <span class="status-color">{{clinicalTrial.status}}</span>
        </div>
        <div class="Spacebox__t-small">
          <span class="icon__Link therapyMatch-tooltip clinical-tooltip" genTooltip [tooltipPosition]="'right'" [appendToBody]="true" [tooltipShow]="true">
          </span>
          <span class="Spacebox__l-tiny pointer btn btn-link clinical-trainId"
            (click)="openReference(clinicalTrial.trialID)">{{clinicalTrial.trialID}}</span>
        </div>
        <div class="Spacebox__t-small" *ngIf="clinicalTrial.phase || clinicalTrial.phases">
          <span class="icon__clock"></span>
          <span class="Spacebox__l-tiny bold">{{(clinicalTrial.phase || clinicalTrial.phases.join(', '))}}</span>
        </div>
      </div>
    </div>
  </div>
</section>